export default __webpack_public_path__ + "static/media/info.5f68c72b.svg";